import SelectBox from "components/Common/SelectBox"
import React from "react"
import { Table } from "reactstrap"

export default function DesignNDetail({ data }) {
  const {
    model,
    pleats1,
    pleats2,
    front,
    sidePocket,
    pissPocket1,
    pissPocket2,
    flap,
    takeOutYourBelt,
    outerSideStitch,
    beltLoop,
    adjuster,
    beltWidth,
    hemSpecification,
    backOfTheKnee,
    suspenderButton,
  } = data
  return (
    <>
      <p className="text-center">DESIGN/DETAIL</p>
      <Table bordered>
        <tbody>
          <tr>
            <th style={{ width: 135 }}>モデル</th>
            <td>
              <SelectBox
                options={[]}
                value={{
                  label: model,
                  value: model,
                }}
                isDisabled={true}
              />
            </td>
          </tr>

          <tr>
            <th>プリーツ</th>
            <td>
              <SelectBox
                options={[]}
                value={{
                  label: pleats1,
                  value: pleats1,
                }}
                isDisabled
              />
            </td>
          </tr>
          <tr>
            <th>プリーツ</th>
            <td>
              <SelectBox
                options={[]}
                value={{
                  label: pleats2,
                  value: pleats2,
                }}
                isDisabled
              />
            </td>
          </tr>
          <tr>
            <th>フロント</th>
            <td>
              <SelectBox
                options={[]}
                value={{
                  label: front,
                  value: front,
                }}
                isDisabled
              />
            </td>
          </tr>
          <tr>
            <th>脇ポケット</th>
            <td>
              <SelectBox
                options={[]}
                value={{
                  label: sidePocket,
                  value: sidePocket,
                }}
                isDisabled
              />
            </td>
          </tr>
          <tr>
            <th>ピスポケット</th>
            <td>
              <SelectBox
                options={[]}
                value={{
                  label: pissPocket1,
                  value: pissPocket1,
                }}
                isDisabled
              />
            </td>
          </tr>
          <tr>
            <th>ピスポケット</th>
            <td>
              <SelectBox
                options={[]}
                value={{
                  label: pissPocket2,
                  value: pissPocket2,
                }}
                isDisabled
              />
            </td>
          </tr>
          <tr>
            <th>フラップ</th>
            <td>
              <SelectBox
                options={[]}
                value={{
                  label: flap,
                  value: flap,
                }}
                isDisabled
              />
            </td>
          </tr>
          <tr>
            <th>ベルト持出</th>
            <td>
              <SelectBox
                options={[]}
                value={{
                  label: takeOutYourBelt,
                  value: takeOutYourBelt,
                }}
                isDisabled
              />
            </td>
          </tr>
          <tr>
            <th>外脇ステッチ</th>
            <td>
              <SelectBox
                options={[]}
                value={{
                  label: outerSideStitch,
                  value: outerSideStitch,
                }}
                isDisabled
              />
            </td>
          </tr>
          <tr>
            <th>ベルトループ</th>
            <td>
              <SelectBox
                options={[]}
                value={{
                  label: beltLoop,
                  value: beltLoop,
                }}
                isDisabled
              />
            </td>
          </tr>
          <tr>
            <th>アジャスター</th>
            <td>
              <SelectBox
                options={[]}
                value={{
                  label: adjuster,
                  value: adjuster,
                }}
                isDisabled
              />
            </td>
          </tr>
          <tr>
            <th>ベルト巾</th>
            <td>
              <SelectBox
                options={[]}
                value={{
                  label: beltWidth,
                  value: beltWidth,
                }}
                isDisabled
              />
            </td>
          </tr>
          <tr>
            <th>裾口仕様</th>
            <td>
              <SelectBox
                options={[]}
                value={{
                  label: hemSpecification,
                  value: hemSpecification,
                }}
                isDisabled
              />
            </td>
          </tr>
          <tr>
            <th>ひざ裏</th>
            <td>
              <SelectBox
                options={[]}
                value={{
                  label: backOfTheKnee,
                  value: backOfTheKnee,
                }}
                isDisabled
              />
            </td>
          </tr>
          <tr>
            <th>サスペンダー釦</th>
            <td>
              <SelectBox
                options={[]}
                value={{
                  label: suspenderButton,
                  value: suspenderButton,
                }}
                isDisabled
              />
            </td>
          </tr>
        </tbody>
      </Table>
    </>
  )
}
